import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class UploadPresetService {
  private lastSelectedSkillMapId: string | null = null

  /** 前回アップロード成功時に選択されていたスキルマップ ID を返す。 */
  getLastSelectedSkillMapId(): string | null {
    return this.lastSelectedSkillMapId
  }

  /** 次回アップロードモーダルの初期選択に使うスキルマップ ID を保存する。 */
  setLastSelectedSkillMapId(skillMapId: string): void {
    this.lastSelectedSkillMapId = skillMapId
  }
}
